import {
  invalidateExecutionRunDetail,
  invalidateGridQuery,
  invalidateMetricsPrefix,
  invalidateResultsFileDetails,
  invalidateSuiteDetail,
  invalidateSuiteRunDetail,
  invalidateTestDetail,
  invalidateTestRunSummaries,
  invalidateTestRunDetail,
  invalidateTestRuns,
  gridPaths,
  queryKeys,
} from '@/shared/hooks';
import { executionKeys } from './executionsQueryKeys';
import type { SuiteRunDto, TestRunDto } from '@flowqa/shared';
import type { QueryFilters } from '@tanstack/react-query';

export const buildTestRunParentInvalidations = (
  execution: Pick<
    TestRunDto,
    | 'organisationId'
    | 'projectId'
    | 'resultsFileId'
    | 'runId'
    | 'runNumber'
    | 'suiteRunId'
    | 'suiteSlug'
    | 'testSlug'
  >,
): QueryFilters[] => {
  const filters: QueryFilters[] = [
    invalidateExecutionRunDetail(execution.runId, execution.organisationId ?? null),
    invalidateMetricsPrefix(),
    invalidateSuiteRunDetail(execution.suiteRunId, execution.organisationId ?? null),
    invalidateTestDetail(
      execution.testSlug ?? null,
      execution.organisationId ?? null,
      execution.projectId,
    ),
    invalidateResultsFileDetails(execution.organisationId ?? null),
    invalidateTestRunSummaries(),
    {
      queryKey: executionKeys.suiteRunDetailByRunNumberPrefix(
        execution.suiteSlug ?? null,
        execution.projectId,
        execution.organisationId ?? null,
      ),
    },
    {
      queryKey: executionKeys.testRunDetailByRunNumber(
        execution.testSlug ?? null,
        execution.runNumber ?? null,
        execution.projectId,
        execution.organisationId ?? null,
      ),
    },
  ];
  return filters;
};

export const buildSuiteRunParentInvalidations = (
  execution: Pick<
    SuiteRunDto,
    'organisationId' | 'projectId' | 'resultsFileId' | 'runId' | 'runNumber' | 'suiteSlug'
  >,
): QueryFilters[] => {
  const filters: QueryFilters[] = [
    invalidateExecutionRunDetail(execution.runId, execution.organisationId ?? null),
    invalidateMetricsPrefix(),
    invalidateResultsFileDetails(execution.organisationId ?? null),
    invalidateSuiteDetail(
      execution.suiteSlug ?? null,
      execution.organisationId ?? null,
      execution.projectId,
    ),
    {
      queryKey: executionKeys.suiteRunDetailByRunNumber(
        execution.suiteSlug ?? null,
        execution.runNumber ?? null,
        execution.projectId,
        execution.organisationId ?? null,
      ),
    },
  ];
  return filters;
};

export const buildTestRunTagUpdateInvalidations = ({
  organisationId,
  projectId,
  testRunId,
}: {
  organisationId?: string | null;
  projectId?: string | null;
  testRunId: string;
}): QueryFilters[] => {
  return [
    { queryKey: queryKeys.tagOptions(projectId ?? null, organisationId ?? null) },
    invalidateTestRuns(projectId ?? null, organisationId ?? null),
    invalidateTestRunDetail(testRunId, organisationId ?? null),
    invalidateGridQuery(gridPaths.testRuns),
  ];
};
